import dayjs from "dayjs";
import { NonProductionDayDrawerType } from "us.collection.admin/components/NonProductionDays/Constants";
import { DateFormats, RedDay } from "us.collection.admin/constants";
import { INonProductionDay } from "us.collection.admin/interfaces";
import { handleEndPointLocals } from "us.common/functions";

/**
 * @function
 * @description get drawer title
 * @param {INonProductionDay} values
 * @param {NonProductionDayDrawerType} values
 * @returns {string}
 */
export const getDrawerTitle = (
  values: INonProductionDay,
  drawerType: NonProductionDayDrawerType
): string => {
  try {
    const { key, reason } = values;

    // If drawer is VIEW → return view title
    if (drawerType === NonProductionDayDrawerType.VIEW) {
      return handleEndPointLocals("US.COLLECTION.ADMIN:NON_PRODUCTION_DAYS.VIEW_NON_PRODUCTION_DATE");
    }

    // EDIT vs ADD
    return !key.isEmpty()
      ? `${handleEndPointLocals("US.COMMON:COMMON.EDIT")} : ${reason}`
      : handleEndPointLocals("US.COLLECTION.COMMON:COMMON.ADD_NEW");

  } catch (error) {
    return "";
  }
};
/**
 * @function
 * @description check whether non production date is same as today
 * @param {string} nonProductionDate non production date
 * @returns {boolean}
 */
export const isNonProductionDateToday = (
  nonProductionDate: string
): boolean => {
  try {
    return dayjs(nonProductionDate).isSame(dayjs().format(DateFormats.REQ));
  } catch (error) {
    return false;
  }
};

/**
 * @function
 * @description check whether non production date is same of before today
 * @param {string} nonProductionDate non production date
 * @returns {boolean}
 */
export const isPreviousOrCurrentDate = (nonProductionDate: string): boolean => {
  try {
    return dayjs(nonProductionDate).isSameOrBefore(
      dayjs().format(DateFormats.REQ)
    );
  } catch (error) {
    return false;
  }
};

/**
 * @function
 * @description filter and sort red days
 * @param {Array<RedDay>} redDays non-production days list
 * @param { any } selectedCriteria selected format
 * @param { any } selectedYear selected year
 * @returns {Array<RedDay>} filtered array list
 */
export const getFilteredRedDays = (
  redDays: Array<RedDay>,
  selectedCriteria: any,
  selectedYear: any
): Array<RedDay> => {
  try {
    if (Array.isArray(redDays) && redDays.length > 0) {
      return redDays
        .filter((day: RedDay) => {
          const startYear = new Date(day.startDate).getFullYear();
          const endYear = new Date(day.endDate).getFullYear();
          return (
            day[selectedCriteria as keyof RedDay] === true &&
            (startYear == selectedYear || endYear == selectedYear)
          );
        })
        .sort(
          (a: any, b: any) =>
            new Date(b.startDate).getTime() - new Date(a.startDate).getTime()
        );
    } else {
      return redDays;
    }
  } catch (error) {
    return redDays;
  }
};
